import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "updater-container"
};
const _hoisted_2 = {
  class: "form-title"
};
const _hoisted_3 = {
  class: "preview-container"
};
const _hoisted_4 = {
  class: "options-container"
};
const _hoisted_5 = {
  style: {
    "text-align": "left",
    "width": "100%"
  }
};
const _hoisted_6 = {
  key: 0,
  class: "tips"
};
const _hoisted_7 = {
  style: {
    "flex": "1"
  }
};
import { ref, computed, watch, onMounted } from 'vue';
import { ElButton, ElInput, ElInputNumber, ElMessage, ElRow, ElSelect } from 'element-plus';
import { mapSpriteResources, stageMapTypes } from "@/tools/utils";
import MapCore from "@/components/Stage/MapCore.vue";
import SpriteGridView from "@/components/Stage/SpriteGridView.vue";
import 'element-plus/es/components/progress/style/css'; // constants

export default {
  __name: 'MapGenerator',
  props: {
    mapData: {
      type: Object,
      required: true
    },
    defaultMapId: {
      type: [String, null],
      required: false,
      default: null
    }
  },
  emits: ['submitUpdates', 'submitDelete', 'close'],

  setup(__props, {
    emit: __emit
  }) {
    const predefineColors = ['#ff4500', '#ff8c00', '#ffd700', '#90ee90', '#00ced1', '#1e90ff', '#c71585']; // pre-declaration

    const props = __props;
    const emits = __emit; // refs

    const currentMapId = ref(null);
    const form = ref({
      type: 0,
      name: '',
      width: 17,
      height: 7,
      data: {}
    });
    const updates = ref({
      'label': '',
      'font_color': null,
      'font_size': 12,
      'font_weight': false,
      'fill_color': null,
      'stroke_color': null,
      'image_data': null
    });
    const mapCore = ref(null);
    const spriteView = ref(null);
    const selectMode = ref(0);
    const operatingCells = ref([]);
    const selectSpriteId = ref(null);
    const spriteScale = ref(1.0); // computed

    const selectSprite = computed(() => {
      if (selectSpriteId.value === null) return null;
      return mapSpriteResources.find(item => item.id === selectSpriteId.value);
    });
    const currentMapData = computed(() => {
      if (props.mapData === null || currentMapId.value === null) return null;
      if (!Object.keys(props.mapData).includes(currentMapId.value)) return null;
      const mapData = props.mapData[currentMapId.value]; // console.log(`mapData = ${JSON.stringify(mapData)}`)

      return {
        'map_id': currentMapId.value,
        ...mapData
      };
    });
    const isCreate = computed(() => currentMapId.value === null || currentMapId.value === undefined); // functions

    const getMapTitle = item => {
      let mapType = '';

      if (stageMapTypes.map(item => item.id).includes(item.type)) {
        mapType = `【${stageMapTypes[item.type].name}】`;
      }

      return `${mapType} ${item.name}`;
    };

    const submit = formData => {
      if (!formData.name || formData.name.trim().length === 0) {
        ElMessage.error({
          message: '需要一个有效的地图名称',
          duration: 1500
        });
        return;
      }

      emits('submitUpdates', formData);
      ElMessage.success({
        message: '数据已同步',
        duration: 1500
      });
      emits('close');
    };

    const copyMap = () => {
      const {
        map_id,
        ...copyData
      } = form.value;
      void map_id; // console.log(JSON.stringify(copyData))

      submit(copyData);
      emits('close');
    };

    const deleteMap = () => {
      emits('submitDelete', form.value.map_id);
      ElMessage.success({
        message: '数据已更新',
        duration: 1500
      });
      emits('close');
    };

    const resetUpdates = () => {
      updates.value = {
        'label': '',
        'font_color': null,
        'font_size': 12,
        'font_weight': false,
        'fill_color': null,
        'stroke_color': null,
        'image_data': null
      };
      spriteScale.value = 1.0;
      if (spriteView.value) spriteView.value.cancelSelect;
    };

    const redraw = () => {
      if (mapCore.value) {
        mapCore.value.requestRender();
      }
    };

    const selectedCell = coord => {
      if (!coord || coord.length !== 2) return;
      const coordKey = coord.join(',');

      if (selectMode.value === 0) {
        if (operatingCells.value.includes(coordKey)) {
          operatingCells.value = [];
        } else {
          operatingCells.value = [coordKey];
        }
      } else if (selectMode.value === 1) {
        if (operatingCells.value.includes(coordKey)) {
          operatingCells.value.splice(operatingCells.value.indexOf(coordKey), 1);
        } else {
          operatingCells.value.push(coordKey);
        }
      }

      resetUpdates();
      redraw();
    };

    const applyCellStyle = (key, value) => {
      if (!operatingCells.value || operatingCells.value === 0) return;
      const dataKeys = Object.keys(form.value.data);
      const buffer = {
        [key]: value
      };

      for (const cellKey of operatingCells.value) {
        if (!dataKeys.includes(cellKey)) {
          form.value.data[cellKey] = buffer;
        } else {
          form.value.data[cellKey] = { ...form.value.data[cellKey],
            ...buffer
          };
        }
      }

      redraw();
    };

    const changeImageData = imageData => {
      updates.value['image_data'] = imageData;
      applyCellStyle('image_data', imageData);
    };

    const clearImageData = () => {
      updates.value['image_data'] = null;
      applyCellStyle('image_data', null);
    };

    const changeFontWeight = () => {
      updates.value['font_weight'] = !updates.value['font_weight'];
      applyCellStyle('font_weight', updates.value['font_weight']);
    };

    const changeSpriteScale = () => {
      const imageData = { ...updates.value['image_data'],
        ...{
          'scale': spriteScale.value
        }
      };
      applyCellStyle('image_data', imageData);
    }; // lifecycle


    onMounted(() => {
      if (props.mapData) {
        const mapDataKeys = Object.keys(props.mapData);
        if (props.defaultMapId) if (mapDataKeys.length > 0) {
          if (props.defaultMapId && mapDataKeys.includes(props.defaultMapId)) {
            currentMapId.value = props.defaultMapId;
          } else if (!props.defaultMapId) {
            currentMapId.value = Object.keys(props.mapData)[0];
          }
        }
      }
    }); // watcher

    watch(() => currentMapData.value, newValue => {
      // console.log(JSON.stringify(newValue))
      if (newValue) {
        form.value = newValue;
      } else {
        form.value = {
          type: 0,
          name: '',
          width: 20,
          height: 14,
          data: {}
        };
      }
    }, {
      deep: true,
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_color_picker = _resolveComponent("el-color-picker");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(ElRow), {
        style: {
          "align-items": "center"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("text", _hoisted_2, _toDisplayString(isCreate.value ? '地图创建' : '地图更新'), 1), _createVNode(_unref(ElSelect), {
          modelValue: currentMapId.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => currentMapId.value = $event),
          "show-arrow": false,
          clearable: "",
          class: "map-selector",
          "popper-class": "commonPopper"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(__props.mapData), ([key, item], index) => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: index,
              label: getMapTitle(item),
              value: key
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        style: {
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(MapCore, {
          ref_key: "mapCore",
          ref: mapCore,
          "map-data": form.value,
          "show-center-coords": false,
          "show-coords": true,
          locked: false,
          "max-scale": 1.5,
          "min-scale": 0.5,
          "operating-cells": operatingCells.value,
          onClickCell: selectedCell
        }, null, 8, ["map-data", "operating-cells"])]), _createElementVNode("div", _hoisted_4, [_createVNode(_unref(ElRow), {
          class: "cell-option-item"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_unref(ElRow), {
            style: {
              "width": "100%"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "地图类型",
              "label-position": "left"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElSelect), {
                modelValue: form.value.type,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.type = $event),
                "show-arrow": false,
                "popper-class": "commonPopper"
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(stageMapTypes), item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: item.id,
                    label: item.name,
                    value: item.id
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"]), _unref(stageMapTypes).map(item => item.id).includes(form.value.type) ? (_openBlock(), _createElementBlock("text", _hoisted_6, _toDisplayString(_unref(stageMapTypes)[form.value.type].desc), 1)) : _createCommentVNode("", true)]),
              _: 1
            })]),
            _: 1
          })])]),
          _: 1
        }), _createVNode(_unref(ElRow), {
          class: "cell-option-item"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "地图名称",
            "label-position": "left"
          }, {
            default: _withCtx(() => [_createVNode(_unref(ElInput), {
              modelValue: form.value.name,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.name = $event),
              maxlength: "16",
              clearable: "",
              "show-word-limit": "",
              placeholder: "地图名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_unref(ElRow), {
          class: "cell-option-item"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "地图尺寸",
            "label-position": "left"
          }, {
            default: _withCtx(() => [_createVNode(_unref(ElInputNumber), {
              modelValue: form.value.width,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.width = $event),
              min: 3,
              max: 39,
              step: 2,
              placeholder: "宽度",
              onChange: redraw
            }, null, 8, ["modelValue"]), _cache[17] || (_cache[17] = _createElementVNode("div", {
              style: {
                "width": "8px"
              }
            }, null, -1)), _createVNode(_unref(ElInputNumber), {
              modelValue: form.value.height,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.height = $event),
              min: 3,
              max: 39,
              step: 2,
              placeholder: "宽度",
              onChange: redraw
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _cache[24] || (_cache[24] = _createElementVNode("div", {
          class: "divider"
        }, null, -1)), _createVNode(_unref(ElRow), {
          class: "cell-option-item"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "操作模式",
            "label-position": "left"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: selectMode.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => selectMode.value = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                value: 0
              }, {
                default: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createTextVNode("单选模式", -1)]))]),
                _: 1
              }), _createVNode(_component_el_radio, {
                value: 1
              }, {
                default: _withCtx(() => [...(_cache[19] || (_cache[19] = [_createTextVNode("多选模式", -1)]))]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_unref(ElRow), {
          class: "cell-option-item"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "填充文本",
            "label-position": "left"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createVNode(_unref(ElInput), {
              modelValue: updates.value.label,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => updates.value.label = $event),
              maxlength: "10",
              clearable: "",
              placeholder: "标签文本",
              onChange: _cache[7] || (_cache[7] = $event => applyCellStyle('label', updates.value.label === '' ? null : updates.value.label))
            }, null, 8, ["modelValue"])]), _cache[20] || (_cache[20] = _createElementVNode("div", {
              style: {
                "width": "8px"
              }
            }, null, -1)), _createVNode(_component_el_color_picker, {
              modelValue: updates.value.font_color,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => updates.value.font_color = $event),
              "show-alpha": "",
              predefine: predefineColors,
              onChange: _cache[9] || (_cache[9] = $event => applyCellStyle('font_color', updates.value.font_color))
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_unref(ElRow), {
          class: "cell-option-item"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "字号大小",
            "label-position": "left"
          }, {
            default: _withCtx(() => [_createVNode(_unref(ElInputNumber), {
              modelValue: updates.value.font_size,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => updates.value.font_size = $event),
              min: 10,
              max: 16,
              step: 1,
              placeholder: "字体大小",
              onChange: _cache[11] || (_cache[11] = $event => applyCellStyle('font_size', updates.value.font_size))
            }, null, 8, ["modelValue"]), _cache[22] || (_cache[22] = _createElementVNode("div", {
              style: {
                "width": "8px"
              }
            }, null, -1)), _createVNode(_unref(ElButton), {
              class: _normalizeClass(["font-weight", updates.value.font_weight ? 'bold' : '']),
              onClick: changeFontWeight
            }, {
              default: _withCtx(() => [...(_cache[21] || (_cache[21] = [_createTextVNode(" B ", -1)]))]),
              _: 1
            }, 8, ["class"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_unref(ElRow), {
          class: "cell-option-item"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "背景色",
            "label-position": "left"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_color_picker, {
              modelValue: updates.value.fill_color,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => updates.value.fill_color = $event),
              "show-alpha": "",
              predefine: predefineColors,
              onChange: _cache[13] || (_cache[13] = $event => applyCellStyle('fill_color', updates.value.fill_color))
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_unref(ElRow), {
          class: "cell-option-item"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "图标集",
            "label-position": "left"
          }, {
            default: _withCtx(() => [_createVNode(_unref(ElSelect), {
              modelValue: selectSpriteId.value,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => selectSpriteId.value = $event),
              "show-arrow": false,
              clearable: "",
              "popper-class": "commonPopper",
              placeholder: "选择图标集"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mapSpriteResources), item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.name,
                  value: item.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"]), _createVNode(_unref(ElButton), {
              class: "clear-sprite",
              onClick: clearImageData
            }, {
              default: _withCtx(() => [...(_cache[23] || (_cache[23] = [_createTextVNode("清除", -1)]))]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), updates.value.image_data ? (_openBlock(), _createBlock(_unref(ElRow), {
          key: 0
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "缩放比例",
            "label-position": "left"
          }, {
            default: _withCtx(() => [_createVNode(_unref(ElInputNumber), {
              modelValue: spriteScale.value,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => spriteScale.value = $event),
              min: 0.5,
              max: 1.0,
              step: 0.1,
              placeholder: "缩放比例",
              onChange: changeSpriteScale
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })) : _createCommentVNode("", true)]), _createVNode(_unref(ElRow), {
          class: "operator-container"
        }, {
          default: _withCtx(() => [!isCreate.value ? (_openBlock(), _createBlock(_unref(ElButton), {
            key: 0,
            onClick: deleteMap
          }, {
            default: _withCtx(() => [...(_cache[25] || (_cache[25] = [_createTextVNode(" 删除该地图 ", -1)]))]),
            _: 1
          })) : _createCommentVNode("", true), !isCreate.value ? (_openBlock(), _createBlock(_unref(ElButton), {
            key: 1,
            onClick: copyMap
          }, {
            default: _withCtx(() => [...(_cache[26] || (_cache[26] = [_createTextVNode(" 以当前数据创建新地图 ", -1)]))]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_unref(ElButton), {
            onClick: _cache[16] || (_cache[16] = $event => submit(form.value))
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(isCreate.value ? '提交创建' : '提交更新'), 1)]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), selectSprite.value ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 0,
        style: {
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [_createVNode(SpriteGridView, {
          ref_key: "spriteView",
          ref: spriteView,
          "sprite-image-path": selectSprite.value?.pngFile ?? null,
          "json-path": selectSprite.value?.jsonFile ?? null,
          "cell-size": 44,
          onSelect: changeImageData
        }, null, 8, ["sprite-image-path", "json-path"])]),
        _: 1
      })) : _createCommentVNode("", true)]);
    };
  }

};